import { NgModule } from '@angular/core';

import {
  PostErinnerungCommandServiceModule,
  PostErinnerungCommandComponentModule
} from '.';

@NgModule({
  imports: [
    PostErinnerungCommandServiceModule,
    PostErinnerungCommandComponentModule
  ],
  exports: [
    PostErinnerungCommandServiceModule,
    PostErinnerungCommandComponentModule
  ]
})
export class PostErinnerungCommandModule { }
